import { render, staticRenderFns } from "./CreateSnapshotPolicy.vue?vue&type=template&id=609c0da6&scoped=true"
import script from "./CreateSnapshotPolicy.vue?vue&type=script&lang=js"
export * from "./CreateSnapshotPolicy.vue?vue&type=script&lang=js"
import style0 from "./CreateSnapshotPolicy.vue?vue&type=style&index=0&id=609c0da6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609c0da6",
  null
  
)

export default component.exports